var _objectSpread = require("/root/workspace/testing-alimini-h5_wKLh/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");
var _classCallCheck = require("/root/workspace/testing-alimini-h5_wKLh/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/root/workspace/testing-alimini-h5_wKLh/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/root/workspace/testing-alimini-h5_wKLh/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _isNativeReflectConstruct = require("/root/workspace/testing-alimini-h5_wKLh/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/isNativeReflectConstruct");
var _getPrototypeOf = require("/root/workspace/testing-alimini-h5_wKLh/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/root/workspace/testing-alimini-h5_wKLh/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
!function (t, e) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = e();else if ("function" == typeof define && define.amd) define([], e);else {
    var n = e();
    for (var r in n) ("object" == typeof exports ? exports : t)[r] = n[r];
  }
}(window, function () {
  return function (t) {
    var e = {};
    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) n.d(r, o, function (e) {
        return t[e];
      }.bind(null, o));
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "/", n(n.s = 1);
  }([function (t, e, n) {
    "use strict";

    t.exports = n(2);
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0),
      o = n.n(r);
    n(4);
    e.default = /*#__PURE__*/function (_r$Component) {
      function _class(t) {
        var _this;
        _classCallCheck(this, _class);
        _this = _callSuper(this, _class, [t]), _this.state = {
          oLeft: "",
          oTop: ""
        }, _this.$vm = null, _this.moving = !1, _this.oW = null, _this.oH = null, _this.htmlWidth = null, _this.htmlHeight = null, _this.bWidth = null, _this.bHeight = null, _this.click = !1;
        return _this;
      }
      _inherits(_class, _r$Component);
      return _createClass(_class, [{
        key: "onTouchStart",
        value: function onTouchStart(t) {
          t = t.touches[0], this.click = !0, this.oW = t.clientX - this.$vm.getBoundingClientRect().left, this.oH = t.clientY - this.$vm.getBoundingClientRect().top, this.htmlWidth = document.documentElement.clientWidth, this.htmlHeight = document.documentElement.clientHeight, this.bWidth = this.$vm.offsetWidth, this.bHeight = this.$vm.offsetHeight;
          var e = t.clientX - this.oW,
            n = t.clientY - this.oH;
          this.setState({
            oLeft: e,
            oTop: n
          }), this.moving = !0;
        }
      }, {
        key: "onTouchEnd",
        value: function onTouchEnd(t) {
          this.moving = !1, this.$vm.className = this.$vm.className + " t-suspend-button-animate";
          var e = this.state.oLeft;
          e = e < (this.htmlWidth - this.bWidth) / 2 ? 0 : this.htmlWidth - this.bWidth, this.click && this.props.onClick(), this.setState({
            oLeft: e
          });
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          this.$vm.addEventListener("touchmove", function (t) {
            t.cancelable && t.preventDefault();
          }, {
            passive: !1
          });
        }
      }, {
        key: "onTouchMove",
        value: function onTouchMove(t) {
          this.$vm.className = "t-suspend-button", this.moving && this.onMove(t);
        }
      }, {
        key: "onMove",
        value: function onMove(t) {
          t = t.touches[0], this.click = !1;
          var e = t.clientX - this.oW,
            n = t.clientY - this.oH;
          e < 0 ? e = 0 : e > this.htmlWidth - this.bWidth && (e = this.htmlWidth - this.bWidth), n < 0 ? n = 0 : n > this.htmlHeight - this.bHeight && (n = this.htmlHeight - this.bHeight), this.setState({
            oLeft: e,
            oTop: n
          });
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;
          var _this$props = this.props,
            t = _this$props.img,
            e = _this$props.style;
          return o.a.createElement("span", {
            className: "t-suspend-button",
            ref: function ref(t) {
              return _this2.$vm = t;
            },
            onTouchStart: function onTouchStart(t) {
              return _this2.onTouchStart(t);
            },
            onTouchMove: function onTouchMove(t) {
              return _this2.onTouchMove(t);
            },
            onTouchEnd: function onTouchEnd(t) {
              return _this2.onTouchEnd(t);
            },
            style: _objectSpread({
              left: "".concat(this.state.oLeft, "px"),
              top: "".concat(this.state.oTop, "px")
            }, e)
          }, t && o.a.createElement("img", {
            src: t,
            alt: ""
          }));
        }
      }]);
    }(r.Component);
  }, function (t, e, n) {
    "use strict";

    /** @license React v16.8.6
     * react.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var r = n(3),
      o = "function" == typeof Symbol && Symbol.for,
      i = o ? Symbol.for("react.element") : 60103,
      u = o ? Symbol.for("react.portal") : 60106,
      s = o ? Symbol.for("react.fragment") : 60107,
      c = o ? Symbol.for("react.strict_mode") : 60108,
      a = o ? Symbol.for("react.profiler") : 60114,
      l = o ? Symbol.for("react.provider") : 60109,
      f = o ? Symbol.for("react.context") : 60110,
      p = o ? Symbol.for("react.concurrent_mode") : 60111,
      h = o ? Symbol.for("react.forward_ref") : 60112,
      d = o ? Symbol.for("react.suspense") : 60113,
      y = o ? Symbol.for("react.memo") : 60115,
      m = o ? Symbol.for("react.lazy") : 60116,
      v = "function" == typeof Symbol && Symbol.iterator;
    function b(t) {
      for (var e = arguments.length - 1, n = "https://reactjs.org/docs/error-decoder.html?invariant=" + t, r = 0; r < e; r++) n += "&args[]=" + encodeURIComponent(arguments[r + 1]);
      !function (t, e, n, r, o, i, u, s) {
        if (!t) {
          if (t = void 0, void 0 === e) t = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
            var c = [n, r, o, i, u, s],
              a = 0;
            (t = Error(e.replace(/%s/g, function () {
              return c[a++];
            }))).name = "Invariant Violation";
          }
          throw t.framesToPop = 1, t;
        }
      }(!1, "Minified React error #" + t + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", n);
    }
    var g = {
        isMounted: function isMounted() {
          return !1;
        },
        enqueueForceUpdate: function enqueueForceUpdate() {},
        enqueueReplaceState: function enqueueReplaceState() {},
        enqueueSetState: function enqueueSetState() {}
      },
      w = {};
    function S(t, e, n) {
      this.props = t, this.context = e, this.refs = w, this.updater = n || g;
    }
    function x() {}
    function j(t, e, n) {
      this.props = t, this.context = e, this.refs = w, this.updater = n || g;
    }
    S.prototype.isReactComponent = {}, S.prototype.setState = function (t, e) {
      "object" != typeof t && "function" != typeof t && null != t && b("85"), this.updater.enqueueSetState(this, t, e, "setState");
    }, S.prototype.forceUpdate = function (t) {
      this.updater.enqueueForceUpdate(this, t, "forceUpdate");
    }, x.prototype = S.prototype;
    var O = j.prototype = new x();
    O.constructor = j, r(O, S.prototype), O.isPureReactComponent = !0;
    var _ = {
        current: null
      },
      k = {
        current: null
      },
      $ = Object.prototype.hasOwnProperty,
      C = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      };
    function E(t, e, n) {
      var r = void 0,
        o = {},
        u = null,
        s = null;
      if (null != e) for (r in void 0 !== e.ref && (s = e.ref), void 0 !== e.key && (u = "" + e.key), e) $.call(e, r) && !C.hasOwnProperty(r) && (o[r] = e[r]);
      var c = arguments.length - 2;
      if (1 === c) o.children = n;else if (1 < c) {
        for (var a = Array(c), l = 0; l < c; l++) a[l] = arguments[l + 2];
        o.children = a;
      }
      if (t && t.defaultProps) for (r in c = t.defaultProps) void 0 === o[r] && (o[r] = c[r]);
      return {
        $$typeof: i,
        type: t,
        key: u,
        ref: s,
        props: o,
        _owner: k.current
      };
    }
    function R(t) {
      return "object" == typeof t && null !== t && t.$$typeof === i;
    }
    var T = /\/+/g,
      L = [];
    function U(t, e, n, r) {
      if (L.length) {
        var o = L.pop();
        return o.result = t, o.keyPrefix = e, o.func = n, o.context = r, o.count = 0, o;
      }
      return {
        result: t,
        keyPrefix: e,
        func: n,
        context: r,
        count: 0
      };
    }
    function M(t) {
      t.result = null, t.keyPrefix = null, t.func = null, t.context = null, t.count = 0, 10 > L.length && L.push(t);
    }
    function P(t, e, n) {
      return null == t ? 0 : function t(e, n, r, o) {
        var s = typeof e;
        "undefined" !== s && "boolean" !== s || (e = null);
        var c = !1;
        if (null === e) c = !0;else switch (s) {
          case "string":
          case "number":
            c = !0;
            break;
          case "object":
            switch (e.$$typeof) {
              case i:
              case u:
                c = !0;
            }
        }
        if (c) return r(o, e, "" === n ? "." + A(e, 0) : n), 1;
        if (c = 0, n = "" === n ? "." : n + ":", Array.isArray(e)) for (var a = 0; a < e.length; a++) {
          var l = n + A(s = e[a], a);
          c += t(s, l, r, o);
        } else if (l = null === e || "object" != typeof e ? null : "function" == typeof (l = v && e[v] || e["@@iterator"]) ? l : null, "function" == typeof l) for (e = l.call(e), a = 0; !(s = e.next()).done;) c += t(s = s.value, l = n + A(s, a++), r, o);else "object" === s && b("31", "[object Object]" == (r = "" + e) ? "object with keys {" + Object.keys(e).join(", ") + "}" : r, "");
        return c;
      }(t, "", e, n);
    }
    function A(t, e) {
      return "object" == typeof t && null !== t && null != t.key ? function (t) {
        var e = {
          "=": "=0",
          ":": "=2"
        };
        return "$" + ("" + t).replace(/[=:]/g, function (t) {
          return e[t];
        });
      }(t.key) : e.toString(36);
    }
    function W(t, e) {
      t.func.call(t.context, e, t.count++);
    }
    function H(t, e, n) {
      var r = t.result,
        o = t.keyPrefix;
      t = t.func.call(t.context, e, t.count++), Array.isArray(t) ? I(t, r, n, function (t) {
        return t;
      }) : null != t && (R(t) && (t = function (t, e) {
        return {
          $$typeof: i,
          type: t.type,
          key: e,
          ref: t.ref,
          props: t.props,
          _owner: t._owner
        };
      }(t, o + (!t.key || e && e.key === t.key ? "" : ("" + t.key).replace(T, "$&/") + "/") + n)), r.push(t));
    }
    function I(t, e, n, r, o) {
      var i = "";
      null != n && (i = ("" + n).replace(T, "$&/") + "/"), P(t, H, e = U(e, i, r, o)), M(e);
    }
    function N() {
      var t = _.current;
      return null === t && b("321"), t;
    }
    var B = {
        Children: {
          map: function map(t, e, n) {
            if (null == t) return t;
            var r = [];
            return I(t, r, null, e, n), r;
          },
          forEach: function forEach(t, e, n) {
            if (null == t) return t;
            P(t, W, e = U(null, null, e, n)), M(e);
          },
          count: function count(t) {
            return P(t, function () {
              return null;
            }, null);
          },
          toArray: function toArray(t) {
            var e = [];
            return I(t, e, null, function (t) {
              return t;
            }), e;
          },
          only: function only(t) {
            return R(t) || b("143"), t;
          }
        },
        createRef: function createRef() {
          return {
            current: null
          };
        },
        Component: S,
        PureComponent: j,
        createContext: function createContext(t, e) {
          return void 0 === e && (e = null), (t = {
            $$typeof: f,
            _calculateChangedBits: e,
            _currentValue: t,
            _currentValue2: t,
            _threadCount: 0,
            Provider: null,
            Consumer: null
          }).Provider = {
            $$typeof: l,
            _context: t
          }, t.Consumer = t;
        },
        forwardRef: function forwardRef(t) {
          return {
            $$typeof: h,
            render: t
          };
        },
        lazy: function lazy(t) {
          return {
            $$typeof: m,
            _ctor: t,
            _status: -1,
            _result: null
          };
        },
        memo: function memo(t, e) {
          return {
            $$typeof: y,
            type: t,
            compare: void 0 === e ? null : e
          };
        },
        useCallback: function useCallback(t, e) {
          return N().useCallback(t, e);
        },
        useContext: function useContext(t, e) {
          return N().useContext(t, e);
        },
        useEffect: function useEffect(t, e) {
          return N().useEffect(t, e);
        },
        useImperativeHandle: function useImperativeHandle(t, e, n) {
          return N().useImperativeHandle(t, e, n);
        },
        useDebugValue: function useDebugValue() {},
        useLayoutEffect: function useLayoutEffect(t, e) {
          return N().useLayoutEffect(t, e);
        },
        useMemo: function useMemo(t, e) {
          return N().useMemo(t, e);
        },
        useReducer: function useReducer(t, e, n) {
          return N().useReducer(t, e, n);
        },
        useRef: function useRef(t) {
          return N().useRef(t);
        },
        useState: function useState(t) {
          return N().useState(t);
        },
        Fragment: s,
        StrictMode: c,
        Suspense: d,
        createElement: E,
        cloneElement: function cloneElement(t, e, n) {
          null == t && b("267", t);
          var o = void 0,
            u = r({}, t.props),
            s = t.key,
            c = t.ref,
            a = t._owner;
          if (null != e) {
            void 0 !== e.ref && (c = e.ref, a = k.current), void 0 !== e.key && (s = "" + e.key);
            var l = void 0;
            for (o in t.type && t.type.defaultProps && (l = t.type.defaultProps), e) $.call(e, o) && !C.hasOwnProperty(o) && (u[o] = void 0 === e[o] && void 0 !== l ? l[o] : e[o]);
          }
          if (1 === (o = arguments.length - 2)) u.children = n;else if (1 < o) {
            l = Array(o);
            for (var f = 0; f < o; f++) l[f] = arguments[f + 2];
            u.children = l;
          }
          return {
            $$typeof: i,
            type: t.type,
            key: s,
            ref: c,
            props: u,
            _owner: a
          };
        },
        createFactory: function createFactory(t) {
          var e = E.bind(null, t);
          return e.type = t, e;
        },
        isValidElement: R,
        version: "16.8.6",
        unstable_ConcurrentMode: p,
        unstable_Profiler: a,
        __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
          ReactCurrentDispatcher: _,
          ReactCurrentOwner: k,
          assign: r
        }
      },
      q = {
        default: B
      },
      D = q && B || q;
    t.exports = D.default || D;
  }, function (t, e, n) {
    "use strict";

    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */
    var r = Object.getOwnPropertySymbols,
      o = Object.prototype.hasOwnProperty,
      i = Object.prototype.propertyIsEnumerable;
    t.exports = function () {
      try {
        if (!Object.assign) return !1;
        var t = new String("abc");
        if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;
        for (var e = {}, n = 0; n < 10; n++) e["_" + String.fromCharCode(n)] = n;
        if ("0123456789" !== Object.getOwnPropertyNames(e).map(function (t) {
          return e[t];
        }).join("")) return !1;
        var r = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (t) {
          r[t] = t;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
      } catch (t) {
        return !1;
      }
    }() ? Object.assign : function (t, e) {
      for (var n, u, s = function (t) {
          if (null == t) throw new TypeError("Object.assign cannot be called with null or undefined");
          return Object(t);
        }(t), c = 1; c < arguments.length; c++) {
        for (var a in n = Object(arguments[c])) o.call(n, a) && (s[a] = n[a]);
        if (r) {
          u = r(n);
          for (var l = 0; l < u.length; l++) i.call(n, u[l]) && (s[u[l]] = n[u[l]]);
        }
      }
      return s;
    };
  }, function (t, e, n) {
    var r = n(5);
    "string" == typeof r && (r = [[t.i, r, ""]]);
    var o = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(7)(r, o);
    r.locals && (t.exports = r.locals);
  }, function (t, e, n) {
    (t.exports = n(6)(!1)).push([t.i, ".t-suspend-button {\n  position: fixed;\n  top: 400px;\n  right: 0;\n  width: 4rem;\n  height: 4rem;\n  border-radius: 2rem;\n  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.4); }\n\n.t-suspend-button img {\n  width: 100%;\n  height: 100%; }\n\n.t-suspend-button-animate {\n  -webkit-transition-duration: .4s;\n          transition-duration: .4s; }\n", ""]);
  }, function (t, e, n) {
    "use strict";

    t.exports = function (t) {
      var e = [];
      return e.toString = function () {
        return this.map(function (e) {
          var n = function (t, e) {
            var n = t[1] || "",
              r = t[3];
            if (!r) return n;
            if (e && "function" == typeof btoa) {
              var o = (u = r, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(u)))) + " */"),
                i = r.sources.map(function (t) {
                  return "/*# sourceURL=" + r.sourceRoot + t + " */";
                });
              return [n].concat(i).concat([o]).join("\n");
            }
            var u;
            return [n].join("\n");
          }(e, t);
          return e[2] ? "@media " + e[2] + "{" + n + "}" : n;
        }).join("");
      }, e.i = function (t, n) {
        "string" == typeof t && (t = [[null, t, ""]]);
        for (var r = {}, o = 0; o < this.length; o++) {
          var i = this[o][0];
          null != i && (r[i] = !0);
        }
        for (o = 0; o < t.length; o++) {
          var u = t[o];
          null != u[0] && r[u[0]] || (n && !u[2] ? u[2] = n : n && (u[2] = "(" + u[2] + ") and (" + n + ")"), e.push(u));
        }
      }, e;
    };
  }, function (t, e, n) {
    var r,
      o,
      i = {},
      u = (r = function r() {
        return window && document && document.all && !window.atob;
      }, function () {
        return void 0 === o && (o = r.apply(this, arguments)), o;
      }),
      s = function (t) {
        var e = {};
        return function (t, n) {
          if ("function" == typeof t) return t();
          if (void 0 === e[t]) {
            var r = function (t, e) {
              return e ? e.querySelector(t) : document.querySelector(t);
            }.call(this, t, n);
            if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
              r = r.contentDocument.head;
            } catch (t) {
              r = null;
            }
            e[t] = r;
          }
          return e[t];
        };
      }(),
      c = null,
      a = 0,
      l = [],
      f = n(8);
    function p(t, e) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n],
          o = i[r.id];
        if (o) {
          o.refs++;
          for (var u = 0; u < o.parts.length; u++) o.parts[u](r.parts[u]);
          for (; u < r.parts.length; u++) o.parts.push(b(r.parts[u], e));
        } else {
          var s = [];
          for (u = 0; u < r.parts.length; u++) s.push(b(r.parts[u], e));
          i[r.id] = {
            id: r.id,
            refs: 1,
            parts: s
          };
        }
      }
    }
    function h(t, e) {
      for (var n = [], r = {}, o = 0; o < t.length; o++) {
        var i = t[o],
          u = e.base ? i[0] + e.base : i[0],
          s = {
            css: i[1],
            media: i[2],
            sourceMap: i[3]
          };
        r[u] ? r[u].parts.push(s) : n.push(r[u] = {
          id: u,
          parts: [s]
        });
      }
      return n;
    }
    function d(t, e) {
      var n = s(t.insertInto);
      if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var r = l[l.length - 1];
      if ("top" === t.insertAt) r ? r.nextSibling ? n.insertBefore(e, r.nextSibling) : n.appendChild(e) : n.insertBefore(e, n.firstChild), l.push(e);else if ("bottom" === t.insertAt) n.appendChild(e);else {
        if ("object" != typeof t.insertAt || !t.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var o = s(t.insertAt.before, n);
        n.insertBefore(e, o);
      }
    }
    function y(t) {
      if (null === t.parentNode) return !1;
      t.parentNode.removeChild(t);
      var e = l.indexOf(t);
      e >= 0 && l.splice(e, 1);
    }
    function m(t) {
      var e = document.createElement("style");
      if (void 0 === t.attrs.type && (t.attrs.type = "text/css"), void 0 === t.attrs.nonce) {
        var r = function () {
          0;
          return n.nc;
        }();
        r && (t.attrs.nonce = r);
      }
      return v(e, t.attrs), d(t, e), e;
    }
    function v(t, e) {
      Object.keys(e).forEach(function (n) {
        t.setAttribute(n, e[n]);
      });
    }
    function b(t, e) {
      var n, r, o, i;
      if (e.transform && t.css) {
        if (!(i = "function" == typeof e.transform ? e.transform(t.css) : e.transform.default(t.css))) return function () {};
        t.css = i;
      }
      if (e.singleton) {
        var u = a++;
        n = c || (c = m(e)), r = S.bind(null, n, u, !1), o = S.bind(null, n, u, !0);
      } else t.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = function (t) {
        var e = document.createElement("link");
        return void 0 === t.attrs.type && (t.attrs.type = "text/css"), t.attrs.rel = "stylesheet", v(e, t.attrs), d(t, e), e;
      }(e), r = function (t, e, n) {
        var r = n.css,
          o = n.sourceMap,
          i = void 0 === e.convertToAbsoluteUrls && o;
        (e.convertToAbsoluteUrls || i) && (r = f(r));
        o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
        var u = new Blob([r], {
            type: "text/css"
          }),
          s = t.href;
        t.href = URL.createObjectURL(u), s && URL.revokeObjectURL(s);
      }.bind(null, n, e), o = function o() {
        y(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = m(e), r = function (t, e) {
        var n = e.css,
          r = e.media;
        r && t.setAttribute("media", r);
        if (t.styleSheet) t.styleSheet.cssText = n;else {
          for (; t.firstChild;) t.removeChild(t.firstChild);
          t.appendChild(document.createTextNode(n));
        }
      }.bind(null, n), o = function o() {
        y(n);
      });
      return r(t), function (e) {
        if (e) {
          if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
          r(t = e);
        } else o();
      };
    }
    t.exports = function (t, e) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (e = e || {}).attrs = "object" == typeof e.attrs ? e.attrs : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = u()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");
      var n = h(t, e);
      return p(n, e), function (t) {
        for (var r = [], o = 0; o < n.length; o++) {
          var u = n[o];
          (s = i[u.id]).refs--, r.push(s);
        }
        t && p(h(t, e), e);
        for (o = 0; o < r.length; o++) {
          var s;
          if (0 === (s = r[o]).refs) {
            for (var c = 0; c < s.parts.length; c++) s.parts[c]();
            delete i[s.id];
          }
        }
      };
    };
    var g,
      w = (g = [], function (t, e) {
        return g[t] = e, g.filter(Boolean).join("\n");
      });
    function S(t, e, n, r) {
      var o = n ? "" : r.css;
      if (t.styleSheet) t.styleSheet.cssText = w(e, o);else {
        var i = document.createTextNode(o),
          u = t.childNodes;
        u[e] && t.removeChild(u[e]), u.length ? t.insertBefore(i, u[e]) : t.appendChild(i);
      }
    }
  }, function (t, e) {
    t.exports = function (t) {
      var e = "undefined" != typeof window && window.location;
      if (!e) throw new Error("fixUrls requires window.location");
      if (!t || "string" != typeof t) return t;
      var n = e.protocol + "//" + e.host,
        r = n + e.pathname.replace(/\/[^\/]*$/, "/");
      return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (t, e) {
        var o,
          i = e.trim().replace(/^"(.*)"$/, function (t, e) {
            return e;
          }).replace(/^'(.*)'$/, function (t, e) {
            return e;
          });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(i) ? t : (o = 0 === i.indexOf("//") ? i : 0 === i.indexOf("/") ? n + i : r + i.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
      });
    };
  }]);
});